// extracted by mini-css-extract-plugin
module.exports = {"addedInfo":"Pieces_addedInfo__3mUwo","dataItem":"Pieces_dataItem__2grGM"};